import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "../../css/components/popups/DefaultPopUp.css";

const ModalPopup = ({
    isOpen,
    onClose,
    title,
    subtext,
    cancelText = "Cancel",
    actionText,
    onAction,
}) => {
    // Close modal on ESC key
    useEffect(() => {
        const handleEsc = (e) => { if (e.key === "Escape") onClose(); };
        window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, [onClose]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
            >
                <h2 className="modal-title">{title}</h2>
                <p className="modal-subtext">{subtext}</p>

                <div className="modal-buttons">
                    <button className="modal-btn cancel-btn" onClick={onClose}>
                        {cancelText}
                    </button>

                    {actionText && (
                        <button
                            className="modal-btn modal-action-btn"
                            onClick={() => {
                                onAction && onAction();
                                onClose();
                            }}
                        >
                            {actionText}
                        </button>
                    )}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ModalPopup;
